module.exports = __webpack_public_path__ + "img/ic_no_protectedinformation.adcb0737.svg";